import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastMessagesSubject: Subject<Message> = new Subject();
  readonly toastMessages = this.toastMessagesSubject.asObservable();

  constructor() { }

  nextToastMessage(message: Message): void {
    this.toastMessagesSubject.next(message);
  }
}
